/**
 * Type for certification watermark id.
 *
 * NOTE if multiple certification watermarks exist in the DOM, then a unique id should be provided for each one.
 */
export type Id = string;

/**
 * Generates a certification watermark id from a given prefix id and an optional postfix id.
 * @param prefix - The prefix id.
 * @param postfix - The optional postfix of the id.
 */
export function generateId(prefix: Id, postfix?: Id): Id {
  let id = prefix;
  if (postfix) {
    id += '-' + postfix;
  }
  return id;
}
